module.exports = __webpack_public_path__ + "static/two_tenant_rental-f27e5e782b57fdd5678cc12ccab36967.png";